import { GST_REGEX } from '../../../../utils/constants/regex';
import * as yup from 'yup';

export const gstSchemaWithNoValidation = yup.object({
  gstNumber: yup.string(),
  uploadedGstFile: yup.object({
    shortUrl: yup.string(),
    url: yup.string(),
  }),
});

export const gstSchemaWithValidations = yup.object({
  gstNumber: yup
    .string()
    .required('GST number is required')
    .length(15, 'GST number should be 15 characters')
    .matches(GST_REGEX, 'Please enter valid GST number'),
  uploadedGstFile: yup.object({
    shortUrl: yup
      .string()
      .required('Please upload GST document'),
    url: yup
      .string()
      .required('Please upload GST document'),
  }),
});

export const gstSchemaWithCheckbox = yup.object({
  selectGSTCheckboxOption: yup.boolean().default(false),
  gstDetails: gstSchemaWithNoValidation.when(
    'selectGSTCheckboxOption',
    ([selectGSTCheckboxOption], schema) => {
      return selectGSTCheckboxOption
        ? schema
        : schema.concat(gstSchemaWithValidations);
    }
  ),
});
